<template>
  <div class="options-button-container">
    <v-menu
      :close-on-content-click="true"
      offset-y
      class="options-button-select"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-tooltip="tooltip"
          x-small
          text
          class="px-0 py-3"
          v-bind="attrs"
          v-on="on"
          @click.stop="trackOptionsMenu"
        >
          <StIcon
            icon-name="dots-vertical"
            size="22"
          />
        </v-btn>
      </template>

      <v-list class="options-button-select__options">
        <v-list-item
          v-if="hasNotClassified"
          class="options-button-select__item pa-0"
        >
          <v-btn
            x-large
            text
            block
            class="options-button-select__item-content px-4 py-2"
            @click.stop="showNotClassified"
          >
            {{ showNotClassifiedLabel }}
          </v-btn>
        </v-list-item>
        <v-divider v-if="hasNotClassified" />

        <v-list-item
          v-for="(option, index) in optionsDataFiltered"
          :key="index"
          class="options-button-select__item pa-0"
        >
          <v-btn
            v-if="!hasChild(option)"
            x-large
            text
            block
            class="options-button-select__item-content px-4 py-2"
            :disabled="disableButtonExpandedMode(option.isExpandedModeOption)"
            @click="$emit('on-option-menu-click', option.function), trackOption(option)"
          >
            {{ option.name }}
          </v-btn>

          <v-menu
            v-else
            open-on-hover
            offset-x
            class="options-button-select"
            min-width="112"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-large
                text
                block
                class="options-button-select__item-content px-4 py-2"
                v-bind="attrs"
                :disabled="disableButtonExpandedMode(option.isExpandedModeOption)"
                v-on="on"
                @click="trackOption(option)"
              >
                {{ option.name }}
                <StIcon
                  icon-name="menu-right"
                  class="pl-2"
                  size="24"
                />
              </v-btn>
            </template>

            <v-list class="options-button-select__sub-options">
              <v-list-item
                v-for="(subOption, subindex) in option.child"
                :key="subindex"
                class="options-button-select__item pa-0"
              >
                <v-btn
                  x-large
                  text
                  block
                  class="options-button-select__item-content px-4 py-2"
                  :disabled="disableButtonExpandedMode(option.isExpandedModeOption)"
                  @click="subOption.function(), trackOption(subOption)"
                >
                  <StIcon
                    v-if="Boolean(subOption.iconname)"
                    :icon-name="subOption.iconname"
                    class="pr-2"
                    size="24"
                  />

                  {{ subOption.name }}
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import StIcon from '@stilingue/st-icon';
import { trackEventWithUserProperties } from '@/utils/mixpanel';

export default {
  name: 'OptionsButton',
  components: {
    StIcon,
  },
  props: {
    tooltip: {
      type: String,
      default: '',
    },
    optionsData: {
      type: Array,
      default: () => ([]),
    },
    expandedMode: {
      type: Boolean,
      default: false,
    },
    hasNotClassified: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hideNotClassified: true,
      notClassifiedLabels: [
        this.$t('components.OptionsButton.label.notClassifiedLabelPlural'),
        this.$t('components.OptionsButton.label.notClassifiedLabel')],
      notShowClassifiedLabel: this.$t('components.OptionsButton.label.notShowClassifiedLabel'),
      showClassifiedLabel: this.$t('components.OptionsButton.label.showClassifiedLabel'),
    };
  },
  computed: {
    showNotClassifiedLabel() {
      if (this.hideNotClassified) {
        return this.notShowClassifiedLabel;
      }
      return this.showClassifiedLabel;
    },
    optionsDataFiltered() {
      return this.optionsData.filter(item => {
        return item.hidden !== true;
      });
    },
  },
  methods: {
    hasChild(option) {
      return Boolean(option.child);
    },
    showNotClassified() {
      this.hideNotClassified = !this.hideNotClassified;
      this.$emit('on-show-not-classified');
    },
    trackOption(option) {
      trackEventWithUserProperties(option.trackName, option.trackProperties);
    },
    trackOptionsMenu() {
      trackEventWithUserProperties('ST Card Menu Open', {
        title: this.$parent?.card?.props?.title,
        widget: this.$parent?.card?.component,
      });
    },
    disableButtonExpandedMode(isExpandedModeOption) {
      if (this.expandedMode) return !Boolean(isExpandedModeOption);
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
  .options-button-select {
    &__options {
      border: 1px solid var(--ds-color-gray-3);
      box-shadow: var(-ds-light-dropshadow-1);
      border-radius: var(--ds-border-radius-sm);
      padding: var(--ds-spacing-stack-quark) !important;
    }

    &__sub-options {
      width: 112px !important;
      border: var(--ds-border-width-hairline) solid var(--ds-color-gray-3);
      box-shadow: var(-ds-light-dropshadow-1);
      border-radius: var(--ds-border-radius-sm);
      padding: var(--ds-spacing-stack-quark) !important;
    }

    &__item {
      display: flex;
      width: 100% !important;
    }

    &__item-content {
      width: 100% !important;
      text-transform: none;
      justify-content: flex-start;
    }
  }
</style>
